import GSheetReader from "g-sheets-api";

const options = {
  sheetId: "1bxF803aLT-Vsk2nyKi4mbhWl9GbMtSme9aATDVCiP_s",
  sheetNumber: 3,
  returnAllResults: true
};

GSheetReader(options, (results) => {
  document.getElementById("total").innerHTML += results[14].number;
  document.getElementById("agresion").innerHTML = results[0].number;
  document.getElementById("informacion").innerHTML = results[1].number;
  document.getElementById("redes").innerHTML = results[2].number;
  document.getElementById("amenaza").innerHTML = results[3].number;
  document.getElementById("detencion").innerHTML = results[6].number;
  document.getElementById("hostigamiento").innerHTML = results[10].number;
  document.getElementById("robo").innerHTML = results[12].number;
  document.getElementById("obstruccion").innerHTML = results[11].number;
});
